import { createAction } from "../../../Common/_actions/Action";
import { UserStorePayload } from "../../_stores/Store/UserStoreStore";

export enum StoreStoreActionType {
  EditStore = 'STORE_EDIT_STORE',
  EditManyStores = 'STORE_EDIT_MANY_STORES',
  RemoveStore = 'STORE_REMOVE_STORE',
  RemoveStoreBySlug = 'STORE_REMOVE_STORE_BY_SLUG',
}

export const EditStore = (store: UserStorePayload) => createAction(StoreStoreActionType.EditStore, {
  store: store
});

export const EditManyStores = (stores: UserStorePayload[] | Record<string, UserStorePayload>) => createAction(StoreStoreActionType.EditManyStores, {
  stores: stores
});

export const RemoveStore = (id: number) => createAction(StoreStoreActionType.RemoveStore, {
  id: id
});

export const RemoveStoreBySlug = (slug: string) => createAction(StoreStoreActionType.RemoveStoreBySlug, {
  slug: slug
});

export type StoreStoreAction =
    ReturnType<typeof EditStore> |
    ReturnType<typeof EditManyStores> |
    ReturnType<typeof RemoveStore> |
    ReturnType<typeof RemoveStoreBySlug>
